module.exports = __webpack_public_path__ + "static/media/cyy.5b778fe6.png";